<template>
    <div class="col-12">
        <label for="input-select" class="form-label">
            <i v-if="icon" :class="['mdi', icon, 'font-18', 'me-1']"></i>
            {{ label }}
        </label>
    </div>
        <div class="col-12">
            <div class="row g-1">
            <div :class="{'col-12': input.mode == 0, 'col-md-5': input.mode == 1, 'col-md-6': input.mode == 2}">
                <select class="form-select" id="input-select" v-model.number="input.mode">
                    <option value="0">{{ $t('common.disabled') }}</option>
                    <option value="1">{{ $t('externalAlarmInput.internalInput') }}</option>
                    <option v-if="externalAlarms.length > 0" value="2">{{ $t('externalAlarmInput.externalAlarmSystem') }}</option>
                </select>
            </div>
            <template v-if="input.mode == 1">
                <div class="col-12 col-md-5">
                    <select class="form-select" id="input-select" v-model.number="input.input.input_number">
                        <option v-for="input in inputs" :key="input.intput_number" :value="input.input_number">
                            {{ input.toString() }}
                        </option>
                    </select>
                </div>
                <div class="col-12 col-md-2">
                    <select class="form-select" id="type-input-select" v-model="input.input.input_type">
                        <option value="NO">NO</option>
                        <option value="NC">{{ $t('externalInput.normallyClosed') }}</option>
                    </select>
                </div>
            </template>
            <template v-if="input.mode == 2">
                <div class="col-12 col-md-6">
                    <select class="form-select" id="alarm-select" v-model.number="input.external_alarm_id" required>
                        <option disabled value="">{{ $t('externalAlarmInput.selectAlarm') }}</option>
                        <option v-for="alarm in externalAlarms" :key="alarm.id" :value="alarm.id">
                            {{ alarm.name }}
                        </option>
                    </select>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import AlarmInput from '@/models/alarmInput';

export default {
    name: 'ExternalAlarmInput',
    props: {
        label: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        inputValue: {
            type: AlarmInput,
            required: true
        },
        inputs: {
            type: Array,
            required: true
        },
        externalAlarms: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            input: this.inputValue
        };
    },   
};
</script>
